<div class="drag-drop-area"  
      [ngClass]="{ 'bg-blur': load}" 
      (click)="onDragDropClick()" 
      (dragover)="onDragOver($event)" 
      (dragleave)="onDragLeave($event)" 
      (drop)="onDrop($event)">
    
      <div class="load-bluer" *ngIf="load">
        <app-spinner [loading]="load"></app-spinner>
      </div>
    
      <ng-container *ngIf="!image && !logo">
        <i class="fi fi-rr-cloud-upload-alt"></i>
        <span>{{ 'UPLOAD_LOGO' | translate }}</span>

        <!-- <p>{{ 'DRAG_DROP_LOGO' | translate }}</p> -->
      </ng-container>
    
      <ng-container *ngIf="image">
        <img [src]="imageSrc" *ngIf="imageSrc" class="img-fluid">
        <!-- <p>{{ image.name }}</p> -->
        <!-- <button type="button" (click)="clearImage()" class="btn btn-danger mt-2"> -->
          <!-- <fa-icon [icon]="faXmark"></fa-icon>  -->
          <!-- {{ 'CLEAR_IMAGE' | translate }} -->
        <!-- </button> -->
      </ng-container>
    
      <ng-container *ngIf="!image">

          <!-- <span class="icon-6 upload"></span> -->
          <img src="https://s3.eu-north-1.amazonaws.com/menuload.com{{ logo }}" *ngIf="logo" class="img-fluid">
        <!-- <button type="button" (click)="clearImage()" class="btn btn-danger mt-2">
          <fa-icon [icon]="faXmark"></fa-icon>  -->
          <!-- {{ 'CLEAR_IMAGE' | translate }} -->
        <!-- </button> -->
      </ng-container>
      <input type="file" class="form-control form-control-lg" id="image" (change)="onFileChange($event)" hidden>

</div>
<!-- <div *ngFor="let logo of logos">
  <img src="https://s3.eu-north-1.amazonaws.com/menuload.com{{logo.src}}" [alt]="'Logo ' + logo.sizes" width="50" height="50" />
  <p>Size: {{ logo.sizes }}</p>
</div> -->